import React from 'react';
import classnames from 'classnames';

import Radiobutton from '../Radio/radioButton';
import Tooltip from '../Tooltip';
import './SweepTimePicker.css';

export default class SweepTimePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sweepTime: {
        sweepTimeType: "endOfDay",
        customSweepTime: undefined
      },
      validationMgs:false,
      showTooltip: false
    };
  }

  componentWillMount() {
    // if(this.props._value) {
    //   this.setState({sweepTime: this.props._value});
    // }
    if (this.props._value) {
      if(this.props._value.customSweepTime !== undefined && this.props._value.customSweepTime !== null){
        let strHH = this.props._value.customSweepTime.split(":")[0];
        let strMM = this.props._value.customSweepTime.split(":")[1];
        this.setState({
          sweepTime: this.props._value,
          strHH: strHH,
          strMM: strMM
        });
      }else {
        this.setState({
          sweepTime: this.props._value,
        });
      }

    }
  }

  handleSweepTypeChange = (value, name) => {
    var sweepTime = {};
    if(value !== "customTime") {
      sweepTime = {customSweepTime: undefined, [name]: value};
      this.setState({validationMgs:false})
    }else {
      sweepTime = {...this.state.sweepTime, [name]: value};
    }
    this.setState({sweepTime}, () => {
      this.props.setInputvalue(this.state.sweepTime, this.props.name);
    });
  }

  // handleCustomSweepTimeChange = (event) => {
  //   const re = /^[0-9]+$/;
  //
  //   if (event.target.value === '' || re.test(event.target.value)) {
  //     this.setState({
  //       sweepTime: {...this.state.sweepTime, [event.target.name]: event.target.value}
  //     }, () => {
  //       this.props.setInputvalue(this.state.sweepTime, this.props.name);
  //     });
  //   }
  // }
  // colon = (e) => {
  //   var key = window.event ? e.keyCode : e.which;
  //
  //   if (key != '8' && key != '46') {
  //
  //     if (e.target.value.length == 2)
  //
  //     e.target.value += ":";
  //   }
  // }
  showTooltip = () => {
    this.setState({
      showTooltip: true
    })
  }

  hideTooltip = () => {
    this.setState({
      showTooltip: false,
    })
  }
  handleCustomSweepTimeChange = event => {
    //const re = /^[0-9]+$/;
    let time = event.target.value;
    if (event.target.name === "HH") {
      this.setState({ strHH: time }, () => {});
    }
    if (event.target.name === "MM") {
      this.setState({ strMM: time }, () => {});
    }
  };
  validateHHTime = event => {
    var first = event.target.value;

    if (event.target.value.length === 2) {
      //var newreg = /^(([0-1][0-9])|(2[0-3]))[0-5][0-9]$/;

      if (first > 24 || this.state.strMM > 59) {
        this.setState({ validationMgs: true });
      }
    }

    if (first !== "" && first <= 24 && this.state.strMM < 59) {
      this.setState({ validationMgs: false });
    } else if (first === "") {
      this.setState({ validationMgs: true });
    }
    if (event.target.value.length === 1) {
      this.state.strHH = "0" + event.target.value;
    }else if(event.target.value === '24'){
      this.state.strMM = '00'
      this.setState({ validationMgs: false });
    }
    let time = this.state.strHH + ":" + this.state.strMM;
    if(time === ":"){
      time = '';
    }
    this.setState(
      {
        sweepTime: {
          ...this.state.sweepTime,
          customSweepTime: time
        }
      },
      () => {this.props.setInputvalue(this.state.sweepTime, this.props.name)}
    );
    return false;
  };

  validateMMTime = event => {
    var first = event.target.value;

    if (event.target.value.length === 2) {
      //var newreg = /^(([0-1][0-9])|(2[0-3]))[0-5][0-9]$/;

      if (first > 59 || this.state.strHH > 24) {
        this.setState({ validationMgs: true });
      }
    }
    if (first !== ""  && first <= 59 && this.state.strHH < 24) {
      this.setState({ validationMgs: false });
    } else if (first === "") {
      this.setState({ validationMgs: true });
    }
    if (event.target.value.length === 1) {
      this.state.strMM = "0" + event.target.value;
    }else if(this.state.strHH === '24'){
      this.state.strMM = '00'
      this.setState({ validationMgs: false });
    }

    let time = this.state.strHH + ":" + this.state.strMM;
    
    if(time === ":"){
      time = '';
    }
    this.setState(
      {
        sweepTime: {
          ...this.state.sweepTime,
          customSweepTime: time
        }
      },
      () => {this.props.setInputvalue(this.state.sweepTime, this.props.name)}
    );
    return false;
  };

  // validateTime = (event) => {
  //   var first = event.target.value.slice(0,2);
  //   var second = event.target.value.slice(2,4);
  //
  //   if (event.target.value.length === 4) {
  //     var newreg = /^(([0-1][0-9])|(2[0-3]))[0-5][0-9]$/;
  //
  //     if (first > 24 || second > 59) {
  //         this.setState({validationMgs : true})
  //     }else if (!newreg.test(event.target.value)) {
  //         this.setState({validationMgs : true})
  //       //document.getElementById('sweepTime').focus();
  //     }
  //   }
  //   if(first < 24 && second <= 59 && second !=='' && first !==''){
  //     this.setState({validationMgs : false})
  //   } else if(second !=='' && first !==''){
  //     this.setState({validationMgs : true})
  //   }
  //   return false;
  // }

  render() {
    var boxLabelCss = classnames("sweep-time-picker__label", {
      "sweep-time-picker__label--custom-time": this.state.sweepTime.sweepTimeType === "customTime"
    });
    return (
      <div className="sweep-time-picker">
      <label className={boxLabelCss}>{this.props.boxLabel || "Sweep time"}</label>
      <div className="sweep-time-picker__input">
      <label className="radio-label">
      {this.props.subLabels[0].split('=')[1] || "End of Day"}
      <Radiobutton setInputvalue={this.handleSweepTypeChange}
      name={this.props.subNames[0] || "sweepTimeType"}
      disabled={this.props.disabled}
      value={this.props.subValues[0] || "endOfDay"}
      _value={this.state.sweepTime[this.props.subNames[1]] || this.props.defaultValue} />
      </label>
      <label className="radio-label">
      {this.props.subLabels[1].split('=')[1] || "Select time"}
      <Radiobutton setInputvalue={this.handleSweepTypeChange}
      name={this.props.subNames[1] || "sweepTimeType"}
      disabled={this.props.disabled}
      value={this.props.subValues[1] || "customTime"}
      _value={this.state.sweepTime[this.props.subNames[1]] || this.props.defaultValue} />
      </label>
      </div>

      {
        this.state.sweepTime.sweepTimeType === "customTime" ? (
          // <input type="text"
          // name={this.props.subNames[2] || "customSweepTime"}
          // value={this.state.sweepTime[this.props.subNames[2]]}
          // onChange={this.handleCustomSweepTimeChange}
          // maxLength="4"
          // id={this.props.id}
          // onBlur={this.validateTime}
          // placeholder={this.props.customTimePlaceholder || "HH MM"} />
         <div>
          <div className="time">
          <input
          type="text"
          className="time_hh"
          placeholder="HH"
          maxLength="2"
          onKeyDown={this.getHour}
          onBlur={this.validateHHTime}
          onChange={this.handleCustomSweepTimeChange}
          name="HH"
          value={this.state.strHH}
          />
          <span>:</span>
          <input
          type="text"
          className="time_mm"
          placeholder="MM"
          maxLength="2"
          onKeyDown={this.getMin}
          onBlur={this.validateMMTime}
          onChange={this.handleCustomSweepTimeChange}
          name="MM"
          value={this.state.strMM}
          />
        </div>
        <div className="tooltipTextWrapper">
          <i
          className="icon icon-circle-help gdocs-valign-middle gdocs-mleft-5 hintText-icon"
          data-tooltip="sweepTimeZone"
          onMouseEnter={this.showTooltip}
          onMouseLeave={this.hideTooltip}
          >
          </i>
          <Tooltip
          active={this.state.showTooltip}
          position="right"
          arrow="center"
          parent="sweepTimeZone"
          >
          <div className="tooltip-content-hintText">
          <span role="status">{this.props.sweepTime_hintText}</span>
          </div>
          </Tooltip>
          </div>
          </div>

        ) : ''
      }
      {this.state.validationMgs ? <div className="input-error-msg-section float-clear">
      <span className="icon icon-circle-delete-solid"></span>{this.props.message}</div> :''}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/SweepTimePicker/SweepTimePicker.js